import countries from 'i18n-iso-countries'
import locale from 'i18n-iso-countries/langs/en.json'
countries?.registerLocale(locale)

export const i18nCountryNameForCode = (code: string) => {
  if (!code) { return null }
  return countries?.getName(code, 'en', { select: 'official' })
}
